import ApplicationElement from '@effectivastudio/lit-components/components/application_element/element.js';
import style from './application_element_style.lit.css';

ApplicationElement.styles.push(style);
